
import { userManager } from "./Auth";

export async function getValidUser() {
  let user = await userManager.getUser();

  if (!user) return null;

  // ✅ if expired → refresh
  if (user.expired) {
    try {
      user = await userManager.signinSilent(); // ✅ uses refresh token now
      return user;
    } catch (err) {
      console.error("Refresh token failed", err);
      return null;
    }
  }

  return user;
}
